var Intent;
(function (Intent) {
    Intent["NONE"] = "none";
    Intent["PRIMARY"] = "primary";
    Intent["SUCCESS"] = "success";
    Intent["WARNING"] = "warning";
    Intent["DANGER"] = "danger";
})(Intent || (Intent = {}));
export const createPrimaryNotification = (message) => ({
    intent: Intent.PRIMARY,
    message,
});
export const createSuccessNotification = (message, { showIcon = true, icon = "play" } = {}) => {
    return {
        icon: showIcon ? icon : undefined,
        intent: Intent.SUCCESS,
        message,
    };
};
export const createErrorNotification = (message, { showIcon = true, icon = "warning-sign" } = {}) => {
    return {
        icon: showIcon ? icon : undefined,
        intent: Intent.DANGER,
        message,
    };
};
//# sourceMappingURL=creators.js.map